import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AnimatePresence, motion } from 'motion/react';
import { transition, tabVariants, containerVariants, iconVariants, lineVariants } from './variants';
import { useAuth } from '../../../utils/Auth';
import styles from './Tabs.module.css';

export default function Tabs({tab}) {

    const { orgObj } = useAuth();
    const [ searchParams, setSearchParams ] = useSearchParams();
    const ref = searchParams.get('ref');
    const ent = searchParams.get('ent');

    const disabled = useMemo(() => {
        if ((orgObj && orgObj?.hasOwnProperty('signUpComplete')) || (ref && ent === 'true')) { 
            return !orgObj?.signUpComplete;
        } else {
            return false;
        };
    },[orgObj]);

    const handleTabs = (e) => {
        if (disabled) return;
        const tab = e.target.id;
        setSearchParams({ tab, ref });
    };

    return (
        <AnimatePresence mode='wait'>
            {tab && (
                <motion.div
                    className={styles.container}
                    variants={containerVariants}
                    initial='initial'
                    animate='animate'
                    exit='initial'
                >
                    <div className={styles.tabContainer}>
                        <motion.div
                            className={styles.tab}
                            transition={transition}
                            variants={tabVariants}
                            initial={false}
                            animate={tab === 'configure' ? 'active' : 'inactive'}
                            whileHover={tab !== 'configure' ? 'hover' : 'active'}
                            id='configure'
                            onClick={handleTabs}
                        >
                            <motion.span
                                className={styles.icon}
                                transition={transition}
                                variants={iconVariants}
                                initial={false}
                                animate={tab === 'configure' ? 'active' : 'inactive'}
                            ><i className='far fa-sliders' /></motion.span>
                            Configure
                            <motion.span
                                className={styles.line}
                                transition={transition}
                                variants={lineVariants}
                                initial={false}
                                animate={tab === 'configure' ? 'active' : 'inactive'}
                            />
                        </motion.div>
                        <motion.div
                            className={styles.tab}
                            transition={transition}
                            variants={tabVariants}
                            initial={false}
                            animate={tab === 'schedule' ? 'active' : 'inactive'}
                            whileHover={tab !== 'schedule' ? 'hover' : 'active'}
                            id='schedule'
                            onClick={handleTabs}
                        >
                            <motion.span
                                className={styles.icon}
                                transition={transition}
                                variants={iconVariants}
                                initial={false}
                                animate={tab === 'schedule' ? 'active' : 'inactive'}
                            ><i className='far fa-calendar' /></motion.span>
                            Rules
                            <motion.span
                                className={styles.line}
                                transition={transition}
                                variants={lineVariants}
                                initial={false}
                                animate={tab === 'schedule' ? 'active' : 'inactive'}
                            />
                        </motion.div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
